import {
	EDIT_INSURANCE_COMPANY,
	EDIT_INSURANCE_COMPANY_SUCCESS,
	EDIT_INSURANCE_COMPANY_FAIL,
	EDIT_INSURANCE_COMPANY_RESET,
} from '../actions/editInsuranceCompanyAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const editInsuranceCompanyReducer = (state = initialState, action) => {
	switch (action.type) {
		case EDIT_INSURANCE_COMPANY:
			return {
				...state,
				apiState: 'loading',
			};
		case EDIT_INSURANCE_COMPANY_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case EDIT_INSURANCE_COMPANY_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case EDIT_INSURANCE_COMPANY_RESET:
			return initialState;
		default:
			return state;
	}
};

export default editInsuranceCompanyReducer;
